import * as Redux from 'redux';
import { thunk } from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { reducer as mapReducer } from '@wayfinder/vms-map';
import { LandscapeState } from '@wayfinder/vms-state';
import { setStore } from '@wayfinder/vms-state/src/store';

import { Routing, reducers } from './index-vms-state';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose;

const complainingReducer = rootReducer => (state, action) => {
    const dontComplainAbout = [
        'ADD_FEATURES',
        'UPSERT_ENTITIES',
        'SET_METADATA',
        'POI_ROUTE',
        'REMOVE_FEATURE',
        'SET_BADGE',
        'SET_BADGES',
        'SET_CATEGORIES',
        'SHOW_ORDINAL', // might not be a change in ordinal
        'VENUE_ROUTE', // venue might have already been loaded
        'PERFORM_VALIDATION',
        'BEGIN_GET_STATUS',
        'STATUS_SUCCESS',
        'STATUS_FAILURE',
        'BEGIN_PUBLISH',
        'PUBLISH_SUCCESS',
        'PUBLISH_FAILURE',
        'SET_TRACKJS',
    ];

    const lastState = state;
    state = rootReducer(state, action);

    if (state === lastState && dontComplainAbout.indexOf(action.type) === -1) {
        console.error(`Nobody handled: ${action.type}`);
    }
    return state;
};

const featureFlagsReducer = (state = {}) => state;

const makeVmsStore = (initialState = {}) => {
    const history = createBrowserHistory();
    const routingObj = Routing.initializeRouting(history);
    const allReducers = Object.assign(
        {
            map: mapReducer,
            location: routingObj.reducer,
            featureFlags: featureFlagsReducer,
        },
        reducers,
        LandscapeState.landscapeStateReducers,
    );
    const rootReducer = Redux.combineReducers(allReducers);

    const shouldComplain = false;
    const topLevelReducer = shouldComplain ? complainingReducer(rootReducer) : rootReducer;

    const reducer = (state, action) => {
        if (action.type === 'RESET_APP') state = undefined;

        return topLevelReducer(state, action);
    };

    const middlewares = Redux.applyMiddleware(thunk, routingObj.middleware);
    const store = Redux.createStore(reducer, initialState, composeEnhancers(routingObj.enhancer, middlewares));
    setStore(store);
    return store;
};

export { makeVmsStore };
